<template>
    <autocomplete
        ref="autocomplete"
        :search="search"
        placeholder="Buscar experiencia"
        aria-label="Buscar experiencia"
        :get-result-value="getResultValue"
        @submit="handleSubmit"
    ></autocomplete>
</template>

<script>
export default {
    name: 'SearchExperiences',
    props: ['experiences'],
    data () {
        return {
            animals: [
                {name: 'test', id: 1},
                {name: 'test1', id: 2},
                {name: 'test2', id: 3},
                {name: 'test3', id: 4},
                {name: 'test4', id: 5}
            ]
        }
    },

    watch: {
        experiences(val) {
            //console.log(val)
            //console.log(val)
        }
    },
    methods: {
        handleSubmit(result){
            console.log(result);
            this.$router.push({ name: 'DetalleExp', query: { user_id: result.id } })
            location.reload();
        },
        search(input) {
            const that = this
            const result = this.experiences.filter(exp => {
                    return that.validateField(exp, 'longName')
                    .startsWith(input.toLowerCase()) || that.validateField(exp, 'code')
                    .startsWith(input.toLowerCase()) || that.validateField(exp, 'locationDepartments')
                    .startsWith(input.toLowerCase()) || that.validateField(exp, 'locationMunicipalities')
                    .startsWith(input.toLowerCase())
            })
            if (input && input.length < 1) { return [] }
            this.$refs.autocomplete.$refs.input.style.color = 'black'
            if (result.length > 0 ) {
                return result
            } else {
                this.$refs.autocomplete.$refs.input.style.color = 'red'
                return [{code: null}]
            }
            
        },
        validateField(exp, field) {
            //console.log(exp[field])
            if (field === 'locationDepartments')
                return exp[field] ? exp[field].department.toLowerCase(): ''
            else if (field === 'locationMunicipalities')
                return exp[field] ? exp[field].municipality.toLowerCase(): ''
            return exp[field] ? exp[field].toLowerCase(): ''
        },

        // Results come back in the format:
        //
        // {
        //   name: 'lion',
        //   collateral_adjectives: [
        //     'leonine',
        //     'lionish'
        //   ]
        // }
        //
        // We want to display the name 
        getResultValue(result) {
            if (!result.code) {
                return "No existen resultados"
            }
            return result.code + "/" + result.longName
        }
    }
}
</script>

<style>

</style>
